import React, { useEffect, useRef, useState } from 'react';
import Loader from "react-loader-spinner";
import { X, Search, Check2Square, DashCircle, BodyText } from 'react-bootstrap-icons';
import { Table, Modal, Button, Row, Col, Popover, OverlayTrigger, FormGroup } from 'react-bootstrap';
import { getStaffList4Modal } from "../../BaseInfo/store/api/StaffApi";
import { translateError } from '../../store/api/CommonFunctions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faUserCheck } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker2';
import BihamtaTable from '../BihamtaTable';
/**
 * 
 * @components
 * @param {Object} props 
 * @param {function} props.setPopSelectStaff
 * @param {Object} props.popData
 * @param {bool} props.popData.show 
 * @param {bool} props.popData.forAgency
 * @param {bool} props.popData.forMiddleman
 * @param {bool} props.popData.forPersonnel
 * @param {bool} props.popData.excludeAgency
 * @param {bool} props.popData.forUpdateGCard
 * @param {int} props.popData.parentID
 * @param {string} props.popData.value
 * @param {function} props.popData.onSelect 
 * @returns 
 */
const ModalSelectStaff = (props) => {
    const searchData = useRef({});
    const bodyRef = useRef(null);
    const [resultList, setResultList] = useState([]);
    const { setPopSelectStaff, popData } = props;
    const [otherInfo, setOtherInfo] = useState({});
    const { forAgency, forMiddleman, forPersonnel, show, onSelect, value, parentID, excludeAgency, forUpdateGCard } = popData;
    const staffType = forAgency ? "نماینده" : forMiddleman ? "واسط فروش" : forPersonnel ? "پرسنل" : "تکنسین";
    const staffType_ = forAgency ? "agency" : forMiddleman ? "middleman" : forPersonnel ? "personnel" : "staff";
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "کد " + staffType, colName: "Code", showInMobile: true },
        { colTitle: "کد دوم " + staffType, colName: "Code2" },
        { colTitle: "نام " + staffType, colName: "LastName", showInMobile: true },
        { colTitle: "شماره همراه", colName: "Mobile" }
    ]
    const popAssignAgency = ((
        <Popover style={{ fontSize: "12px", fontFamily: "Vazir", minWidth: "300px", pointerEvents: "auto" }} id="popAssignAgency" >
            <Popover.Title className='headerStyle'>اطلاعات تخصیص</Popover.Title>
            <Popover.Content className='bodyStyle'>
                <div>
                    {otherInfo?.LastName &&
                        <label className='mt-1 mb-1' style={{ color: "#ff0031" }}>نماینده انتخاب شده: {(otherInfo.FirstName ?? "") + " " + otherInfo.LastName}</label>}
                    <FormGroup>
                        <DatePicker isGregorian={false} timePicker={false} className="search-input" name="CreateFromDate"
                            onChange={value => otherInfo.InstallDeadline = value.local("en").format("YYYY-MM-DD")} placeholder="مهلت نصب" />
                    </FormGroup>
                    <FormGroup>
                        <select className='form-control' placeholder="فعالسازی" onChange={e => otherInfo.Active = e.target.value} style={{ pointerEvents: "auto" }} onClick={e => e.target.focus()}>
                            <option value="">انتخاب کنید</option>
                            <option value={true}>فعال شود</option>
                        </select>
                    </FormGroup>
                    <div className=' mt-2'>
                        <Button variant='info' className='group-Btn' onClick={() => selectStaff()}><Check2Square size={18} />&nbsp;تخصیص نماینده</Button>
                        <Button variant='danger' className='group-Btn' onClick={cancel}><DashCircle size={18} />&nbsp;انصراف</Button>
                    </div>
                </div>
            </Popover.Content>
        </Popover>)
    )
    function cancel() {
        if (onSelect)
            onSelect(null);
        setOtherInfo({});
        setPopSelectStaff({ show: false });
    }
    const selectStaff = (item) => {
        if (!item?.ID && !otherInfo?.ID) {
            return;
        }
        onSelect({ ...otherInfo, ...item });
        setPopSelectStaff({ show: false });
        otherInfo.current = {};
    }
    function searhKeyDown(e) {
        if (e.key === "Enter") {
            search();
        }
        else if (e.keyCode === 27) {
            cancel();
        }

    }
    const search = (data) => {
        if (data) {
            searchData.current = { ...data };
        }
        else {
            searchData.current.Take = 20;
            if (excludeAgency) {
                searchData.current.IsAgency = false;
            }
            if (parentID) {
                searchData.current.ParentID = parentID;
            }
            else {
                searchData.current.ParentID = null;
            }
        }
        getStaffList4Modal(staffType_, searchData.current, setResultList);
    }
    const rowClick = (row) => {
        if (forUpdateGCard) {
            setOtherInfo({ ...otherInfo, ...row });
            return;
        }
        selectStaff(row);
    }
    useEffect(() => {
        if (show) {
            searchData.current = {};
            const input = document.getElementById("inputSearchStaffName");
            input.focus();
            if (value && value !== '') {
                input.value = value;
            }
        }
    }, [show])
    return (
        <Modal show={show} size='lg' style={{ direction: "rtl" }} onHide={() => { }} onFocus={e => e.preventDefault()}>
            <Modal.Header className='headerStyle'>
                <span>
                    <FontAwesomeIcon icon={faUserCheck} size='lg' />&nbsp;
                    {"انتخاب " + staffType}
                </span>
                <FontAwesomeIcon icon={faTimes} size='lg' onClick={cancel} />
            </Modal.Header>
            <Modal.Body className='bodyStyle' ref={bodyRef}>
                <div className='row mt-0' style={{ marginLeft: "2px", marginRight: "2px" }}>
                    <div className='col-md-3' style={{ padding: "1px" }}>
                        <input placeholder={'کد ' + staffType} type="text" className='search-input' onChange={(e) => searchData.current.Code = e.target.value} onKeyDown={searhKeyDown} />
                    </div>
                    <div className='col-md-3' style={{ padding: "1px" }}>
                        <input placeholder={'کد دوم ' + staffType} type="text" className='search-input' onChange={(e) => searchData.current.Code2 = e.target.value} onKeyDown={searhKeyDown} />
                    </div>
                    <div className='col-md-3' style={{ padding: "1px" }}>
                        <input id="inputSearchStaffName" placeholder={'نام ' + staffType} type="text" className='search-input' onChange={(e) => searchData.current.Name = e.target.value} onKeyDown={searhKeyDown} />
                    </div>
                    <div className='col-md-3' style={{ padding: "1px" }}>
                        <input placeholder={'موبایل ' + staffType} type="text" className='search-input' onChange={(e) => searchData.current.Mobile = e.target.value} onKeyDown={searhKeyDown} />
                    </div>

                </div>
                <div>
                    <Button className="group-Btn-large mt-2 mb-2" onClick={() => search()}><Search size={18} />&nbsp;جستجوی {staffType}</Button>
                </div>
                {forUpdateGCard ?
                    <div className='scThin' style={{ maxHeight: 320, overflow: "auto" }}>
                        <Table className='mb-0'>
                            <thead>
                                <tr>
                                    <th style={{ display: "none", position:"sticky", top:0, background:"#b6b6b6" }}></th>
                                    <th style={{position:"sticky", top:0, background:"#b6b6b6" }}>{"کد " + staffType}</th>
                                    <th style={{position:"sticky", top:0, background:"#b6b6b6" }}>کد دوم {staffType}</th>
                                    <th style={{position:"sticky", top:0, background:"#b6b6b6" }}>{"نام " + staffType}</th>
                                    <th style={{position:"sticky", top:0, background:"#b6b6b6" }}>موبایل</th>
                                </tr>
                            </thead>
                            <tbody>
                                {resultList?.Error &&
                                    <tr>
                                        <td colSpan={3} style={{ textAlign: "center", color: "red" }}>{translateError(resultList.Error)}</td>
                                    </tr>
                                }
                                {(resultList === "PENDING") &&
                                    <tr>
                                        <td colSpan={3} style={{ textAlign: "center" }}>
                                            <Loader type="BallTriangle" color="#bb1370" height={27} width={27} />
                                        </td>
                                    </tr>
                                }
                                {resultList && !resultList.Error && Array.isArray(resultList) &&
                                    resultList.map((item, i) =>

                                        <OverlayTrigger placement='top' trigger="click" overlay={popAssignAgency} key={i}
                                            container={bodyRef.current || undefined}>
                                            <tr key={i} className="resultTableRow" onClick={() => rowClick(item)}>
                                                <td style={{ display: "none" }}></td>
                                                <td>{item.Code}</td>
                                                <td>{item.Code2}</td>
                                                <td>
                                                    {item.LastName}
                                                </td>
                                                <td>{item.Mobile}</td>
                                            </tr>
                                        </OverlayTrigger>

                                    )
                                }
                            </tbody>
                        </Table>
                    </div> :

                    <BihamtaTable columns={tableCols} dataList={{ Data: resultList }} hasPaging={true} filterData={searchData.current}
                        rowClick={rowClick} searchMethod={search} maxHeight={320} pageSizeList={[10, 20, 50, 100]} style={{ whiteSpace: "nowrap" }} />
                }
            </Modal.Body>
        </Modal>
    )
}
export default ModalSelectStaff;